import React from 'react';

const API = `${(process.env.REACT_APP_BACKEND_URL || 'https://bobine.live')}/api`;

const goldBtn = (primary) => ({
  fontFamily: "'Georgia', serif", fontSize: 14, fontWeight: primary ? 600 : 400,
  padding: '12px 28px', borderRadius: 8, cursor: 'pointer',
  letterSpacing: 0.5, transition: 'all 0.3s',
  backgroundColor: primary ? '#D4AF37' : 'transparent',
  color: primary ? '#000' : '#D4AF37',
  border: primary ? 'none' : '1px solid rgba(212,175,55,0.4)',
  boxShadow: primary ? '0 4px 20px rgba(212,175,55,0.3)' : 'none',
});

const ServicesTab = ({
  loading, products, user, currentPlan, photoCount, photoLimit,
  navigate, setActiveTab, redirecting, handleCheckout, setShowNumerisation, t,
}) => {
  const [portalLoading, setPortalLoading] = React.useState(false);

  const openBillingPortal = async () => {
    setPortalLoading(true);
    try {
      const token = localStorage.getItem('bobine_token');
      const res = await fetch(`${API}/billing/portal`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ return_url: window.location.href }),
      });
      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        alert(data.detail || 'Impossible d\'ouvrir le portail de gestion.');
      }
    } catch {
      alert('Erreur de connexion au portail.');
    } finally {
      setPortalLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center py-20">
        <div className="animate-spin rounded-full" style={{ width: 48, height: 48, border: '2px solid transparent', borderTopColor: '#D4AF37', borderBottomColor: '#D4AF37' }} />
      </div>
    );
  }

  return (
    <div>
      {/* Retour vers Tresors */}
      <button
        onClick={() => setActiveTab('tresors')}
        data-testid="back-to-tresors"
        style={{
          fontFamily: "'Georgia', serif", fontSize: 12, color: '#D4AF37',
          backgroundColor: 'transparent', border: '1px solid rgba(212,175,55,0.2)',
          padding: '6px 14px', borderRadius: 6, cursor: 'pointer',
          display: 'flex', alignItems: 'center', gap: 4, marginBottom: 24,
        }}
      >
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>
        {t('dash_back')}
      </button>

      {/* SECTION 1 : MON ABONNEMENT */}
      <div style={{ marginBottom: 40 }}>
        <h3 data-testid="services-section-abonnement" style={{
          fontFamily: "'Georgia', serif", fontSize: 14, color: '#D4AF37',
          letterSpacing: 2, textTransform: 'uppercase', marginBottom: 20,
          textAlign: 'center', fontWeight: 400,
        }}>{t('svc_subscription')}</h3>
        <div style={{
          padding: '24px 28px', borderRadius: 12,
          border: '1px solid rgba(212,175,55,0.25)',
          backgroundColor: 'rgba(212,175,55,0.02)',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16,
        }}>
          <div>
            <p style={{ fontFamily: "'Georgia', serif", fontSize: 18, color: '#D4AF37', marginBottom: 4 }}>
              {user?.plan === 'lignees' ? t('svc_lignees') : user?.plan === 'heritage' ? t('svc_heritage') : t('svc_eveil')}
            </p>
            <p style={{ fontFamily: "'Georgia', serif", fontSize: 13, color: '#FAF3E0' }}>
              {user?.plan === 'lignees' ? t('svc_lignees_desc') : user?.plan === 'heritage' ? t('svc_heritage_desc') : t('svc_free')}
            </p>
            <div data-testid="services-quota" style={{ marginTop: 8 }}>
              {photoLimit > 0 ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <div style={{ flex: 1, maxWidth: 200, height: 4, borderRadius: 2, backgroundColor: 'rgba(212,175,55,0.15)' }}>
                    <div style={{ height: '100%', borderRadius: 2, background: 'linear-gradient(145deg, #D4AF37, #B8860B)', width: `${Math.min(100, (photoCount / photoLimit) * 100)}%`, transition: 'width 0.5s' }} />
                  </div>
                  <span style={{ fontFamily: "'Georgia', serif", fontSize: 12, color: '#D4AF37' }}>
                    {photoCount} / {photoLimit} {t('svc_treasures')}
                  </span>
                </div>
              ) : (
                <span style={{ fontFamily: "'Georgia', serif", fontSize: 12, color: '#D4AF37' }}>
                  {photoCount} {t('svc_treasures')} — {t('svc_unlimited') || 'Illimité'}
                </span>
              )}
            </div>
          </div>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
            {(user?.plan === 'heritage' || user?.plan === 'lignees') && (
              <button
                onClick={openBillingPortal}
                disabled={portalLoading}
                data-testid="manage-subscription-btn"
                style={{
                  ...goldBtn(false), padding: '10px 22px', fontSize: 12, whiteSpace: 'nowrap',
                  opacity: portalLoading ? 0.6 : 1,
                  display: 'inline-flex', alignItems: 'center', gap: 6,
                }}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/>
                </svg>
                {portalLoading ? '...' : (t('svc_manage_subscription') || 'Gérer mon abonnement')}
              </button>
            )}
            {user?.plan !== 'heritage' && user?.plan !== 'lignees' && (
              <button
                onClick={() => navigate('/offres')}
                data-testid="upgrade-plan-btn"
                style={{ ...goldBtn(true), padding: '10px 22px', fontSize: 12, whiteSpace: 'nowrap' }}
              >
                {t('svc_upgrade')}
              </button>
            )}
          </div>
        </div>
      </div>

      {/* SECTION 2 : LIVRES DE PRESTIGE */}
      <div style={{ marginBottom: 40 }}>
        <h3 data-testid="services-section-livres" style={{
          fontFamily: "'Georgia', serif", fontSize: 14, color: '#D4AF37',
          letterSpacing: 2, textTransform: 'uppercase', marginBottom: 8,
          textAlign: 'center', fontWeight: 400,
        }}>{t('svc_books')}</h3>
        {(user?.plan === 'heritage' || user?.plan === 'lignees') && (
          <p style={{ fontFamily: "'Georgia', serif", fontSize: 12, color: '#D4AF37', textAlign: 'center', marginBottom: 16, fontStyle: 'italic' }}>
            {t('svc_discount')}
          </p>
        )}
        <div className="grid md:grid-cols-3 gap-6">
          {products.filter(pr => pr.is_livre).map(p => (
            <div key={p.product_id} data-testid={`service-${p.product_id}`} style={{
              border: p.product_id === 'livre_heritage' ? '2px solid #D4AF37' : '1px solid rgba(212,175,55,0.25)',
              borderRadius: 14, backgroundColor: 'rgba(212,175,55,0.03)',
            }}>
              <div style={{ padding: '24px 20px' }}>
                <div style={{ textAlign: 'center', marginBottom: 16 }}>
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ margin: '0 auto' }}>
                    <path d="M4 19.5A2.5 2.5 0 016.5 17H20" /><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" />
                  </svg>
                </div>
                <h4 style={{ fontFamily: "'Georgia', serif", fontSize: 16, color: '#D4AF37', textAlign: 'center', marginBottom: 4 }}>{p.name}</h4>
                <p style={{ fontFamily: "'Georgia', serif", fontSize: 12, color: '#FAF3E0', textAlign: 'center', marginBottom: 14, lineHeight: 1.5 }}>{p.description}</p>
                <div style={{ textAlign: 'center', marginBottom: 16 }}>
                  {p.original_price && (
                    <span style={{ fontFamily: "'Georgia', serif", fontSize: 14, color: '#FAF3E0', textDecoration: 'line-through', marginRight: 8 }}>
                      {p.original_price.toFixed(2).replace('.', ',')}€
                    </span>
                  )}
                  <span style={{ fontFamily: "'Georgia', serif", fontSize: 26, fontWeight: 500, color: '#D4AF37' }}>
                    {p.price.toFixed(2).replace('.', ',')}€
                  </span>
                  {p.discount_label && (
                    <span style={{ display: 'inline-block', fontFamily: "'Georgia', serif", fontSize: 11, color: '#27ae60', marginLeft: 8, padding: '2px 8px', borderRadius: 4, backgroundColor: 'rgba(39,174,96,0.1)' }}>{p.discount_label}</span>
                  )}
                </div>
                <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 16px 0' }}>
                  {(p.features || []).slice(0, 4).map((f, i) => (
                    <li key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 6, marginBottom: 6 }}>
                      <span style={{ color: '#D4AF37', fontSize: 11, marginTop: 2 }}>&#10003;</span>
                      <span style={{ fontFamily: "'Georgia', serif", fontSize: 11, color: '#FAF3E0', lineHeight: 1.4 }}>{f}</span>
                    </li>
                  ))}
                </ul>
                <button onClick={() => handleCheckout(p.product_id)} disabled={!!redirecting} data-testid={`order-${p.product_id}-button`} style={{ ...goldBtn(true), width: '100%', fontSize: 13, opacity: redirecting === p.product_id ? 0.6 : 1 }}>
                  {redirecting === p.product_id ? t('svc_redirect') : t('svc_order')}
                </button>
                {p.shipping_label && (
                  <p style={{ fontFamily: "'Georgia', serif", fontSize: 10, color: '#D4AF37', textAlign: 'center', marginTop: 8, fontStyle: 'italic' }}>
                    {p.shipping_label}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* SECTION 3 : RESTAURATION + NUMERISATION */}
      <div className="grid md:grid-cols-2 gap-6">
        {/* Restauration Renaissance */}
        {(() => {
          const p = products.find(pr => pr.product_id === 'restauration');
          if (!p) return null;
          const isFree = p.discount_label && p.price === 0;
          return (
            <div data-testid="service-restauration" style={{ border: '1px solid rgba(212,175,55,0.25)', borderRadius: 14 }}>
              <div style={{ padding: '28px 24px' }}>
                <div style={{ textAlign: 'center', marginBottom: 16 }}>
                  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ margin: '0 auto' }}>
                    <path d="M12 3a9 9 0 0 0-9 9h3l-4 4-4-4h3a11 11 0 0 1 11-11z"/><path d="M12 21a9 9 0 0 0 9-9h-3l4-4 4 4h-3a11 11 0 0 1-11 11z"/>
                  </svg>
                </div>
                <h4 style={{ fontFamily: "'Georgia', serif", fontSize: 16, color: '#D4AF37', textAlign: 'center', marginBottom: 8 }}>{p.name}</h4>
                <p style={{ fontFamily: "'Georgia', serif", fontSize: 12, color: '#FAF3E0', textAlign: 'center', marginBottom: 16, lineHeight: 1.5 }}>{p.description}</p>
                <div style={{ textAlign: 'center', marginBottom: 16 }}>
                  {isFree ? (
                    <span style={{ fontFamily: "'Georgia', serif", fontSize: 24, fontWeight: 500, color: '#D4AF37' }}>Inclus</span>
                  ) : (
                    <>
                      <span style={{ fontFamily: "'Georgia', serif", fontSize: 26, fontWeight: 500, color: '#D4AF37' }}>{p.price.toFixed(2).replace('.', ',')}€</span>
                      <span style={{ fontFamily: "'Georgia', serif", fontSize: 12, color: '#D4AF37' }}>/photo</span>
                    </>
                  )}
                </div>
                <button onClick={() => handleCheckout('restauration')} disabled={!!redirecting} data-testid="order-restauration-button" style={{ ...goldBtn(false), width: '100%', opacity: redirecting === 'restauration' ? 0.6 : 1 }}>
                  {redirecting === 'restauration' ? t('svc_redirect') : isFree ? t('svc_restore_free') : t('svc_restore_paid')}
                </button>
              </div>
            </div>
          );
        })()}

        {/* Numerisation Pro */}
        <div data-testid="service-numerisation" style={{ border: '1px solid rgba(212,175,55,0.25)', borderRadius: 14 }}>
          <div style={{ padding: '28px 24px' }}>
            <div style={{ textAlign: 'center', marginBottom: 16 }}>
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ margin: '0 auto' }}>
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/>
              </svg>
            </div>
            <h4 style={{ fontFamily: "'Georgia', serif", fontSize: 16, color: '#D4AF37', textAlign: 'center', marginBottom: 8 }}>{t('svc_digitize')}</h4>
            <p style={{ fontFamily: "'Georgia', serif", fontSize: 12, color: '#FAF3E0', textAlign: 'center', marginBottom: 16, lineHeight: 1.5 }}>
              {t('svc_digitize_desc')}
            </p>
            <div style={{ textAlign: 'center', marginBottom: 16 }}>
              <span style={{ fontFamily: "'Georgia', serif", fontSize: 13, color: '#FAF3E0' }}>À partir de </span>
              <span style={{ fontFamily: "'Georgia', serif", fontSize: 26, fontWeight: 500, color: '#D4AF37' }}>49€</span>
            </div>
            <button onClick={() => navigate('/services')} data-testid="numerisation-cta-button" style={{ ...goldBtn(false), width: '100%' }}>
              {t('svc_discover')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesTab;
